const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

// Use the booked calendar date, not a timezone conversion or a statement filename.
export const bankBookedDate = value => {
  const text = String(value || '').trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/);
  const bkt = text.match(/^(\d{2})-([A-Z]{3})-(\d{2}|\d{4})$/i);
  const parts = iso ? iso.slice(1).map(Number) : bkt
    ? [Number(bkt[3].length === 2 ? `20${bkt[3]}` : bkt[3]), MONTHS.indexOf(bkt[2].toUpperCase()) + 1, Number(bkt[1])]
    : null;
  if (!parts) return '';
  const [year, month, day] = parts;
  const date = new Date(Date.UTC(year, month - 1, day));
  if (year < 1000 || date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const bankMonth = row => bankBookedDate(row.bookedAt).slice(0, 7) || 'undated';
export const bankMonthLabel = month => month === 'all' ? 'All months' : month === 'undated' ? 'Date missing'
  : new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${month}-01T12:00:00Z`));
export const bankMonths = rows => [...new Set(rows.map(bankMonth))].sort((a, b) => a === 'undated' ? 1 : b === 'undated' ? -1 : b.localeCompare(a));

export const readableBankName = name => {
  const text = String(name || '').trim();
  if (/\bbkt\b|banka komb[eë]tare tregtare/i.test(text)) return 'BKT';
  if (/\bpaysera\b/i.test(text)) return 'Paysera';
  return text || 'Bank not identified';
};

export const transactionBank = (row, statements) => readableBankName(row.sourceBank
  || statements.find(statement => statement.id === row.statementId || statement.id === row.intakeId)?.sourceBank);
export const bankFilterKey = name => readableBankName(name).toLowerCase();
export const bankOptions = (rows, statements) => [...new Map(rows.map(row => {
  const label = transactionBank(row, statements);
  return [bankFilterKey(label), { value: bankFilterKey(label), label }];
})).values()].sort((a, b) => a.label.localeCompare(b.label));

export const filterBankWorkspace = (rows, statements, month, bank) => rows.filter(row =>
  (month === 'all' || bankMonth(row) === month) && (bank === 'all' || bankFilterKey(transactionBank(row, statements)) === bank))
  .sort((a, b) => bankBookedDate(b.bookedAt).localeCompare(bankBookedDate(a.bookedAt)));
